"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnDprChanged = void 0;
/**
 * @public
 * Event emitted on screen DPI changing, or when the user zooms the page (browser page scaling).
 */
class OnDprChanged {
    constructor(onDprChanged) {
        this.onDprChanged = onDprChanged;
    }
    static registerListener(eventService, onEvent) {
        return eventService
            .getCategory(OnDprChanged)
            .addTemporaryListener(new OnDprChanged(onEvent));
    }
    static emit(eventService, dpr) {
        const listeners = eventService
            .getCategory(OnDprChanged)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onDprChanged(dpr);
        }
    }
}
exports.OnDprChanged = OnDprChanged;
OnDprChanged.callbackKey = "onDprChanged";
//# sourceMappingURL=on-dpr-changed.js.map